import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { EquipmentStatusVM, SaveEquipmentSummaryNotesModel } from "./summary-notes-model";
import { catchError } from "rxjs/internal/operators/catchError";

@Injectable()
export class EquipmentNotesService {
  constructor(private _http: HttpClient) {}

  private readonly API_BASE = "api/ManageEquipment/";

    saveSummaryNotes(model: SaveEquipmentSummaryNotesModel) : Observable<number> {
        return this._http.post<number>(this.API_BASE + "/SaveSummaryNotes",model).pipe(catchError(this.handleError));
    }

    getSummaryNotes(EquipmentId: number): Observable<any[]> {
        return this._http.get<any[]>(this.API_BASE + "/GetSummaryNotes?equipmentId=" + EquipmentId).pipe(catchError(this.handleError));
    }

    editSummaryNotes(model: EquipmentStatusVM): Observable<boolean> {
        return this._http.post<boolean>(this.API_BASE + '/EditSummaryNotes', model).pipe(catchError(this.handleError));
    }

    changeNotesStatus(model: EquipmentStatusVM): Observable<boolean> {
        return this._http.post<boolean>(this.API_BASE + '/ChangeNotesStatus', model).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);    
        return throwError(
            () => error.message || 'Server error'
        );
    }
}